import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type {
  CreateAffiliatePayoutMethodRequest,
  CreateAffiliatePayoutMethodResponse,
} from './create-affiliate-payout-method.types'

const createAffiliatePayoutMethod = async (
  data: CreateAffiliatePayoutMethodRequest,
): Promise<CreateAffiliatePayoutMethodResponse> => {
  const response = await apiClient.post<CreateAffiliatePayoutMethodResponse>(
    '/v1/affiliation/payout-methods',
    data,
  )
  return response.data
}

interface UseCreateAffiliatePayoutMethodOptions {
  feedback?: MutationFeedback
}

export const useCreateAffiliatePayoutMethod = (
  options?: UseCreateAffiliatePayoutMethodOptions,
) => {
  return useMutation({
    mutationFn: createAffiliatePayoutMethod,
    meta: {
      invalidatesQuery: ['affiliate-payout-methods'],
      ...options?.feedback,
    },
  })
}
